var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slotReel",style:(_vm.reelStyle)},[_c('div',{ref:"reelFrame",staticClass:"slotReelFrame"},_vm._l((_vm.spinSymbols),function(symbol,symbolIndex){return _c('SlotSymbol',{key:symbolIndex,attrs:{"symbol":symbol,"reel-index":_vm.index,"symbol-index":symbolIndex}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }